export function gdprNotice() {
    const notice = document.querySelector('.gdpr-notice');

    if (notice) {
        notice.querySelector('.gdpr-notice-close').addEventListener('click', () => {
            notice.remove();
            setGdpr('gdpr', 'yes', 31536000);
        });
    }
}

function setGdpr(name, value, expires, path, domain, secure) {
    let d = new Date();

    if (typeof(expires) === 'object' && expires.toGMTString) {
        expires = expires.toGMTString();
    } else if (parseInt(expires, 10)) {
        d.setTime(d.getTime() + (parseInt(expires, 10) * 1000));
        expires = d.toGMTString();
    } else {
        expires = '';
    }

    document.cookie = name + '=' + encodeURIComponent(value) +
        (expires ? '; expires=' + expires : '') +
        (path ? '; path=' + path : '; path=/') +
        (domain ? '; domain=' + domain : '') +
        (secure ? '; secure' : '');
}